import { useState } from "react";
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from "@mui/material";
import { LoadingButton } from "@mui/lab";
import { useAuth } from "../../auth/context";
import * as loginGatewayApi from "../../apis/loginGatewayApi";
import { isBeforePasswordExpiryDeadline, PASSWORD_EXPIRY_DEADLINE_LABEL } from "./passwordExpiryDeadline";
import { clearPasswordExpiryReminder, isPasswordExpiryReminderPending } from "./passwordExpiryReminder";

const shouldShowReminder = () => isPasswordExpiryReminderPending() && isBeforePasswordExpiryDeadline();

const messages = {
  idle: `Tenés tiempo para cambiarla hasta el ${PASSWORD_EXPIRY_DEADLINE_LABEL}.`,
  loading: `Tenés tiempo para cambiarla hasta el ${PASSWORD_EXPIRY_DEADLINE_LABEL}.`,
  failed: "No pudimos enviarte el mail para cambiar tu contraseña. Probá de nuevo.",
};

const PasswordExpiryDialog = () => {
  const { user } = useAuth();
  const [open, setOpen] = useState(shouldShowReminder);
  const [status, setStatus] = useState("idle");

  if (!open) return null;

  const close = () => {
    clearPasswordExpiryReminder();
    setOpen(false);
  };

  const requestPasswordChange = () => {
    setStatus("loading");
    loginGatewayApi.requestPasswordRecovery(user.email).then(
      () => setStatus("requested"),
      () => setStatus("failed")
    );
  };

  const actions =
    status === "requested" ? (
      <Button variant="contained" onClick={close}>
        Listo
      </Button>
    ) : (
      <>
        <Button onClick={close}>
          Más tarde
        </Button>
        <LoadingButton variant="contained" loading={status === "loading"} onClick={requestPasswordChange}>
          {status === "failed" ? "Reintentar" : "Cambiarla"}
        </LoadingButton>
      </>
    );

  return (
    <Dialog open onClose={close} fullWidth PaperProps={{ sx: { maxWidth: 520 } }}>
      <DialogTitle sx={{ px: { xs: 3, sm: 4 }, pt: 4, pb: 1, fontSize: { xs: 18, sm: 20 }, color: "primary.main" }}>
        Tu contraseña está próxima a vencer
      </DialogTitle>
      <DialogContent sx={{ px: { xs: 3, sm: 4 }, pt: 1, pb: 3 }}>
        <Typography sx={{ fontSize: 16 }}>
          {status === "requested" ? (
            <>
              Te enviamos un mail a <strong>{user.email}</strong> para que la cambies.
            </>
          ) : (
            messages[status]
          )}
        </Typography>
      </DialogContent>
      <DialogActions sx={{ px: { xs: 3, sm: 4 }, pt: 0, pb: 4, gap: 1 }}>{actions}</DialogActions>
    </Dialog>
  );
};

export default PasswordExpiryDialog;
